export default "/images/vendor/flag-icon-css/flags/1x1/gb-wls.svg?77f90d8e620af4d9604d4da7c7f49346";